import { useContext } from "react";
import { AppStateContext } from "../../state/AppProvider";
import simbalogodark from "../../assets/simbalogodark.png";

interface Props {
    animate: boolean;
}

export const AnswerIcon: React.FC<Props> = ({ animate }) => {
    const appStateContext = useContext(AppStateContext);
    return (
        <div className={`w-10 ${animate ? "circle-icon-animate" : "circle-icon"}`}>
            <img src={simbalogodark} alt={appStateContext?.state?.assistant?.name} />
        </div>
    );
};
